import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommentItem from "./CommentItem";
import { GetPostComments } from './API';

export default function CommentList(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
      
    GetPostComments(props.crsnum,props.ID).then(data => {
      console.log(data);
      setData(data);
    });
  }, [props.crsnum, props.addedCount,props.postaddedCount]);
 
  return (

      <div class="widget-list widget-list-rounded m-b-10" data-id="widget">
        {data.map((item, index) => (
          <CommentItem  Lang={props.Lang} key={index} {...item}/>
        ))}
      </div>
 
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Community/CommentList.js